import MetricChange from '../../MetricChange';
import formatMetricValue from '../../helpers/formatMetricValue';
import getMetricInfo from '../../helpers/getMetricInfo';
import { ChannelBusinessHealthMetric, GlobalBusinessHealthMetric } from '../../types';
import { MetricValueInline, MetricValueMuted } from './styled';

type Snapshot = GlobalBusinessHealthMetric | ChannelBusinessHealthMetric | undefined;

const formatMetricSnapshot = (metricKey: string, snapshot: Snapshot) => {
    const def = getMetricInfo(metricKey);
    const current = snapshot?.current;
    if (current === undefined || !Number.isFinite(current)) {
        return <MetricValueMuted>—</MetricValueMuted>;
    }
    const change = snapshot?.change;
    return (
        <MetricValueInline>
            {formatMetricValue(current, def?.format)}
            {typeof change === 'number' && change !== 0 ? (
                <MetricChange
                    value={change}
                    valueFormat={def?.format}
                    goodWhen={def?.goodWhen}
                />
            ) : null}
        </MetricValueInline>
    );
};

export default formatMetricSnapshot;
